export const buildProperFormatDate = (date: string): string => {
  const splitBy = date.indexOf('/') !== -1 ? '/' : '-';

  const splitDate = date.split(splitBy);
  const year = '19' + splitDate[2];

  return splitDate.slice(0, 2).join('/') + '/' + year;
};
